import api from '../api/axiosConfig';

export const vacancyCandidatesAPi = {
    getCandidatesByVacancy: async (vacancyId) => {
        const response = await api.get(`/vacancy-candidates/by_vacancy/${vacancyId}`, {
            silent: true
        });
        return response.data.data;
    },
    updateCandidateStatus: async (vacancyId, candidateId, statusId) => {
        const requestData = {
            status_id: statusId
        };

        const response = await api.put(`/vacancy-candidates/${vacancyId}/${candidateId}/status`, requestData, {
            loadingMessage: 'Изменение статуса кандидата...',
            successMessage: 'Статус кандидата успешно изменён'
        });
        return response.data;
    },
    updateVacancyCandidate: async (vacancyId, candidateId, data) => {
        const response = await api.put(`/vacancy-candidates/${vacancyId}/${candidateId}/update`, data, {
            loadingMessage: 'Обновление данных кандидата в вакансии...',
            successMessage: 'Данные успешно обновлены'
        });
        return response.data;
    },
    getVacancyByCandidate: async (candidateId) => {
        const response = await api.get(`/vacancy-candidates/by_candidate/${candidateId}`, {
            silent: true
        });
        return response.data.data;
    },
    create: async (vacancyId, candidateId) => {
        const response = await api.post(`/vacancy-candidates/`, { candidate_id: candidateId, vacancy_id: vacancyId }, {
            loadingMessage: 'Добавление кандидата в вакансию...',
            successMessage: 'Кандидат успешно добавлен в вакансию'
        });
        return response.data;
    },
    getAllowedFunnelStatuses: async (vacancyId) => {
        const response = await api.get(`/vacancies/${vacancyId}/allowed-funnel-statuses`, {
            silent: true
        });
        return response.data.data;
    },
    vacancyCandidateReturnToWork: async (vacancyId, candidateId, comment) => {
        const response = await api.put(`/vacancy-candidates/${vacancyId}/${candidateId}/status/revert?comment=${encodeURIComponent(comment)}`, {}, {
            loadingMessage: 'Возврат кандидата в работу...',
            successMessage: 'Кандидат успешно возвращён в работу'
        });
        return response.data;
    }
}